// 绘制的模式
export enum DRAW_MODEL {
  create = "create",
  update = "update",
  read = "read",
  navigationAndMaps = "navigation_and_maps",
  readToCreate = "read_to_create", // 渲染地块并且可以创建
  pureRead = "pureRead", // 不包含任何控件
}
